/* Hair Grow Bites LP — /pages/hair-grow
   Port of the interactive behaviour in Andrew's Claude Design file:
   gallery frames, offer selection, both accordions, rotating mobile trust
   message, sticky bar (shows once the hero scrolls past), add-to-cart. */
(function () {
  'use strict';

  /* Both options are subscriptions. Prices are the plan-adjusted amounts on
     product 8137567469795, not hand-typed: the 3-month plan takes 34% off the
     $177 variant ($116.82, i.e. $38.94/mo) and the monthly plan takes 24% off
     the $59 variant ($44.84/mo). The one-time purchase is the same $59 variant
     with NO plan, and lives on the link under the CTA rather than in here. */
  var OFFERS = {
    sub: {
      variant: '46582099214563',
      sellingPlan: '4404642019',
      // HAIRGROW45 takes $19.82 off the $116.82 plan price to land on $97 flat.
      // recurringCycleLimit is 1, so it is the FIRST order only - the card and
      // the stepup line have to keep saying so.
      discount: 'HAIRGROW45',
      // The two $30 gift variants ride along as separate one-time lines. The
      // "Hair Grow 90-Day Plan: 2 Free Gifts" automatic BXGY zeroes them at
      // checkout, which is what produces the struck $30 next to "Free" - a
      // $0 product would have nothing to strike and checkout ignores
      // compare-at prices. 90-day plan only: the monthly plan's gift arrives
      // on the reorder and is handled in Recharge, not here.
      gifts: ['67625775562979', '67625775628515'],
      // The struck price is the FULL 3-month variant price (3 x $59), shown to
      // the right of what they actually pay. Set as innerHTML, not textContent.
      cta: 'Start My 90-Day Plan · $97 <s>$177</s>',
      stickyTitle: '90-Day Growth Plan (Save 45%)',
      stickySub: '$32.33 per month',
      stickyCta: 'Start My 90-Day Plan · $97 <s>$177</s>',
      stickyCtaMob: 'Start Plan',
      stickyTitleMob: '90-Day Plan · $32.33/mo',
      // Under 375px the selector cannot hold "Plan" at a legible size.
      stickyTitleNarrow: '90-Day · $32.33/mo'
    },
    month: {
      variant: '46582099149027',
      sellingPlan: '4404379875',
      discount: '',
      cta: 'Start My 1-Month Plan · $44.84 <s>$59</s>',
      stickyTitle: '1-Month Plan (Save 24%)',
      stickySub: '$44.84 per month',
      stickyCta: 'Start My 1-Month Plan · $44.84 <s>$59</s>',
      stickyCtaMob: 'Start Plan',
      stickyTitleMob: '1-Month Plan · $44.84/mo',
      stickyTitleNarrow: '1-Month · $44.84/mo'
    }
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Hero gallery ----------
     Holds more frames than the six visible thumbs: arrows, swipe and the
     scrolling thumb strip all cycle through the full set. */
  var frames = $$('.hg-frame');
  var thumbs = $$('.hg-thumb');
  var thumbStrip = $('#hg-thumbs');
  var gal = $('.hg-gal');
  var frameIdx = 0;

  function showFrame(i) {
    if (!frames.length) return;
    frameIdx = (i + frames.length) % frames.length;
    frames.forEach(function (f, n) { f.classList.toggle('is-active', n === frameIdx); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === frameIdx); });
    var active = thumbs[frameIdx];
    if (active && thumbStrip && thumbStrip.scrollWidth > thumbStrip.clientWidth) {
      var s = thumbStrip.getBoundingClientRect();
      var a = active.getBoundingClientRect();
      // Advance by the MINIMUM delta so the rail windows one thumb at a time.
      // Centering used to jump it by half a viewport. Still a rect delta, not
      // scrollIntoView: scrollTo({behavior:'smooth'}) is a silent no-op on this
      // scroll-snap container, and offsetLeft measures against the sticky
      // .hg-hero__gal rather than the strip.
      var GUTTER = 8;
      if (a.left < s.left) {
        thumbStrip.scrollLeft -= (s.left - a.left) + GUTTER;
      } else if (a.right > s.right) {
        thumbStrip.scrollLeft += (a.right - s.right) + GUTTER;
      }
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { showFrame(i); });
  });
  // Both the main-image arrows and the thumb-rail chevrons drive the same frame.
  $$('[data-gal-prev]').forEach(function (b) {
    b.addEventListener('click', function () { showFrame(frameIdx - 1); });
  });
  $$('[data-gal-next]').forEach(function (b) {
    b.addEventListener('click', function () { showFrame(frameIdx + 1); });
  });

  /* Swipe on touch */
  if (gal) {
    var x0 = null, y0 = null;
    gal.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showFrame(frameIdx + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  }

  /* ---------- Offer selection ---------- */
  var cta = $('#hg-cta');
  var stickyCta = $('#hg-sticky-cta');
  var stickyTitle = $('#hg-sticky-title');
  var stickySub = $('#hg-sticky-sub');
  var current = 'sub';

  function isMob() { return window.matchMedia('(max-width: 749px)').matches; }
  function isNarrow() { return window.matchMedia('(max-width: 374px)').matches; }

  function selectOffer(key) {
    var o = OFFERS[key];
    if (!o) return;
    current = key;

    $$('.hg-offer').forEach(function (el) {
      el.classList.toggle('is-sel', el.getAttribute('data-offer') === key);
    });
    $$('.hg-sticky__opt').forEach(function (el) {
      el.classList.toggle('is-sel', el.getAttribute('data-offer') === key);
    });

    if (cta) {
      cta.innerHTML = o.cta;
      cta.setAttribute('data-variant', o.variant);
      cta.setAttribute('data-selling-plan', o.sellingPlan);
      cta.setAttribute('data-discount', o.discount || '');
      cta.setAttribute('data-gifts', (o.gifts || []).join(','));
    }
    if (stickyCta) {
      stickyCta.innerHTML = isMob() ? o.stickyCtaMob : o.stickyCta;
      stickyCta.setAttribute('data-variant', o.variant);
      stickyCta.setAttribute('data-selling-plan', o.sellingPlan);
      stickyCta.setAttribute('data-discount', o.discount || '');
      stickyCta.setAttribute('data-gifts', (o.gifts || []).join(','));
    }
    if (stickyTitle) {
      stickyTitle.textContent = isMob()
        ? (isNarrow() ? o.stickyTitleNarrow : o.stickyTitleMob)
        : o.stickyTitle;
    }
    if (stickySub) stickySub.textContent = o.stickySub;
  }

  $$('.hg-offer').forEach(function (el) {
    el.addEventListener('click', function () { selectOffer(el.getAttribute('data-offer')); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOffer(el.getAttribute('data-offer')); }
    });
  });

  /* ---------- Accordions ---------- */
  function wireAccordion(itemSel, btnSel, exclusive) {
    $$(btnSel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest(itemSel);
        if (!item) return;
        var wasOpen = item.classList.contains('is-open');
        if (exclusive) $$(itemSel + '.is-open').forEach(function (x) { x.classList.remove('is-open'); });
        item.classList.toggle('is-open', !wasOpen);
      });
    });
  }
  wireAccordion('.hg-faq', '.hg-faq__q', true);
  wireAccordion('.hg-bfaq', '.hg-bfaq__q', true);

  /* ---------- Supplement facts modal ---------- */
  var sfModal = $('#hg-sf-modal');
  var sfOpen = $('#hg-sf-open');
  var sfLastFocus = null;

  function closeSf() {
    if (!sfModal) return;
    sfModal.hidden = true;
    document.body.style.overflow = '';
    if (sfLastFocus) sfLastFocus.focus();
  }
  if (sfOpen && sfModal) {
    sfOpen.addEventListener('click', function () {
      sfLastFocus = sfOpen;
      sfModal.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = sfModal.querySelector('.hg-modal__x');
      if (x) x.focus();
    });
    $$('[data-sf-close]', sfModal).forEach(function (el) {
      el.addEventListener('click', closeSf);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sfModal.hidden) closeSf();
    });
  }

  /* ---------- Founder video: click to play ---------- */
  var fv = $('.hg-fv');
  if (fv) {
    var fvVideo = fv.querySelector('video');
    var fvBtn = fv.querySelector('.hg-fv__play');
    if (fvVideo && fvBtn) {
      fvBtn.addEventListener('click', function () {
        fv.classList.add('is-playing');
        fvVideo.setAttribute('controls', 'controls');
        var played = fvVideo.play();
        // Safari rejects play() if the file has not buffered yet; keep the
        // poster/controls state rather than throwing an unhandled rejection.
        if (played && played.catch) played.catch(function () {});
      });
    }
  }

  /* ---------- Sticky bar ---------- */
  var sticky = $('#hg-sticky');
  // Gated on the offer block, not the whole hero: otherwise the bar competes
  // with the in-hero buy box for the same tap while that box is still on screen.
  var hero = $('#offers') || $('#hg-hero');
  var stickyToggle = $('#hg-sticky-toggle');

  if (stickyToggle && sticky) {
    stickyToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      sticky.classList.toggle('menu-open');
    });
    document.addEventListener('click', function (e) {
      if (!sticky.contains(e.target)) sticky.classList.remove('menu-open');
    });
  }
  $$('.hg-sticky__opt').forEach(function (el) {
    el.addEventListener('click', function () {
      selectOffer(el.getAttribute('data-offer'));
      if (sticky) sticky.classList.remove('menu-open');
    });
  });

  function onScroll() {
    if (!sticky || !hero) return;
    sticky.classList.toggle('is-shown', hero.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { selectOffer(current); });
  onScroll();

  /* ---------- Add to cart ---------- */
  function addToCart(btn) {
    var variant = parseInt(btn.getAttribute('data-variant'), 10);
    if (!variant) return;
    var plan = parseInt(btn.getAttribute('data-selling-plan'), 10);
    var item = { id: variant, quantity: 1 };
    if (plan) item.selling_plan = plan;

    // Gift lines are plain one-time items with no selling plan: Recharge only
    // manages the subscription line, so they ship with order 1 and do not
    // recur. The BXGY caps itself at 2 units per order, so a double-click
    // cannot hand out four.
    var items = [item];
    (btn.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
      var id = parseInt(g, 10);
      if (id) items.push({ id: id, quantity: 1 });
    });

    // innerHTML, not textContent: the CTA labels carry a <s> struck price and
    // a textContent round-trip would flatten it to plain text on restore.
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      // /discount/<code>?redirect= applies the code to the session, then lands
      // on checkout. Plain /checkout for anything with no code attached.
      var code = btn.getAttribute('data-discount');
      window.location.href = code
        ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')
        : '/checkout';
    }).catch(function () {
      btn.disabled = false;
      btn.innerHTML = label;
      window.location.href = '/cart';
    });
  }

  var onetime = $('#hg-onetime');
  [cta, stickyCta, onetime].forEach(function (btn) {
    if (btn) btn.addEventListener('click', function () { addToCart(btn); });
  });

  /* ---------- Reviews rail scroll bar ----------
     Native scrollbars are overlay-style on macOS: zero reserved height and
     auto-hiding, so they cannot signal "there is more to see". This draws a
     persistent one that also drags. */
  var revs = $('.hg-revs');
  var revBar = $('.hg-revs-bar');
  var revThumb = $('.hg-revs-bar__thumb');
  var revCtl = $('.hg-revs-ctl');
  var revPrev = $('[data-revs-prev]');
  var revNext = $('[data-revs-next]');
  if (revs && revBar && revThumb) {
    var revMax = function () { return revs.scrollWidth - revs.clientWidth; };
    // One card plus the rail gap, measured live so it tracks the responsive
    // card width rather than a hardcoded number.
    var revStep = function () {
      var card = revs.querySelector('.hg-rev');
      var gap = parseFloat(getComputedStyle(revs).columnGap || getComputedStyle(revs).gap) || 16;
      return card ? card.getBoundingClientRect().width + gap : revs.clientWidth;
    };

    function syncRevBar() {
      var max = revMax();
      var ctl = revCtl || revBar;
      if (max <= 1) { ctl.style.visibility = 'hidden'; return; }
      ctl.style.visibility = '';
      // Floor the thumb so it stays grabbable when the rail is very long.
      var pct = Math.max((revs.clientWidth / revs.scrollWidth) * 100, 12);
      revThumb.style.width = pct + '%';
      revThumb.style.left = (revs.scrollLeft / max) * (100 - pct) + '%';
      if (revPrev) revPrev.disabled = revs.scrollLeft <= 1;
      if (revNext) revNext.disabled = revs.scrollLeft >= max - 1;
    }

    // Direct scrollLeft assignment, not scrollTo({behavior:'smooth'}): smooth
    // scrolling is a silent no-op on this page's scroll-snap containers (see
    // the thumb strip above). The snap settles the rail on a card edge.
    if (revPrev) revPrev.addEventListener('click', function () { revs.scrollLeft -= revStep(); });
    if (revNext) revNext.addEventListener('click', function () { revs.scrollLeft += revStep(); });

    function seekRev(clientX) {
      var track = revBar.getBoundingClientRect();
      var thumbW = revThumb.getBoundingClientRect().width;
      var span = track.width - thumbW;
      if (span <= 0) return;
      var p = (clientX - track.left - thumbW / 2) / span;
      revs.scrollLeft = Math.max(0, Math.min(1, p)) * revMax();
    }

    var revDragging = false;
    revBar.addEventListener('pointerdown', function (e) {
      revDragging = true;
      if (revBar.setPointerCapture) revBar.setPointerCapture(e.pointerId);
      seekRev(e.clientX);
    });
    revBar.addEventListener('pointermove', function (e) { if (revDragging) seekRev(e.clientX); });
    revBar.addEventListener('pointerup', function () { revDragging = false; });
    revBar.addEventListener('pointercancel', function () { revDragging = false; });

    revs.addEventListener('scroll', syncRevBar, { passive: true });
    window.addEventListener('resize', syncRevBar);
    syncRevBar();
  }

  /* ---------- Mobile menu ---------- */
  var header = $('.hg-header');
  var burger = $('.hg-burger');
  if (burger && header) {
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      burger.setAttribute('aria-expanded', header.classList.toggle('menu-open') ? 'true' : 'false');
    });
    $$('.hg-nav a', header).forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('menu-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) header.classList.remove('menu-open');
    });
  }

  selectOffer('sub');
})();
